<template>
  <div class="yearDiv">
    <div class="year">
      <div class='year-text'>{{ year }}</div>
      <img class="downIcon" src="~@/assets/football/down.png"/>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      year: ''
    }
  }
}
</script>

<style lang="sass" scoped>
.yearDiv
  position: absolute
  height: 44px
  min-width: 40px
  right: 0px
  bottom: -13px
.item
  display: flex
.year
  color: white
  font-size: 16
  display: flex
.downIcon
  width: 12px
  height: 12px
  margin-left: 8px
  margin-top: 3px
</style>
